"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOMER_TRIP_TRACKING_ROLES = exports.CUSTOMER_BOOKING_PROCESS_ROLES = exports.CUSTOMER_INTERFACE_ROLES = exports.RolesEnum = exports.InternalRolesEnum = void 0;
exports.includesCustomerInterfaceRole = includesCustomerInterfaceRole;
exports.includesCustomerBookingProcessRole = includesCustomerBookingProcessRole;
exports.includesCustomerTripTrackingRole = includesCustomerTripTrackingRole;
// Internal roles are roles that can be assigned from the management user page UI
var InternalRolesEnum;
(function (InternalRolesEnum) {
    InternalRolesEnum["ManagementAccess"] = "management-access";
    InternalRolesEnum["CustomerSupport"] = "customer-support";
    InternalRolesEnum["DriverSupport"] = "driver-support";
    InternalRolesEnum["ContentManager"] = "content-manager";
    InternalRolesEnum["BizDev"] = "bizdev";
    InternalRolesEnum["RegionalManager"] = "regional-manager";
    InternalRolesEnum["SeniorRegionalManager"] = "senior-regional-manager";
    InternalRolesEnum["SupportMaster"] = "support-master";
    InternalRolesEnum["ClaimingToolSubscriptionMaster"] = "claiming-tool-subscription-master";
    InternalRolesEnum["RefundMaster"] = "refund-master";
    InternalRolesEnum["PayoutMaster"] = "payout-master";
    InternalRolesEnum["CAMaster"] = "ca-master";
    InternalRolesEnum["PricingMaster"] = "pricing-master";
    InternalRolesEnum["Finance"] = "finance";
    InternalRolesEnum["FinanceMaster"] = "finance-master";
    InternalRolesEnum["Product"] = "product";
    InternalRolesEnum["Admin"] = "admin";
    InternalRolesEnum["UserRoleManager"] = "user-role-manager";
    InternalRolesEnum["DriverFaqManager"] = "driver-faq-manager";
})(InternalRolesEnum || (exports.InternalRolesEnum = InternalRolesEnum = {}));
var RolesEnum;
(function (RolesEnum) {
    // -- Internal roles. Assignable from users page and stored in DB. --
    // TODO(mg): dissolve this role by assigning its permissions to all roles having it assigned.
    // Plus adjust the logic allowing logging in to management based on this role presence
    RolesEnum["ManagementAccess"] = "management-access";
    RolesEnum["CustomerSupport"] = "customer-support";
    RolesEnum["DriverSupport"] = "driver-support";
    RolesEnum["ContentManager"] = "content-manager";
    RolesEnum["BizDev"] = "bizdev";
    RolesEnum["RegionalManager"] = "regional-manager";
    RolesEnum["SeniorRegionalManager"] = "senior-regional-manager";
    RolesEnum["SupportMaster"] = "support-master";
    RolesEnum["ClaimingToolSubscriptionMaster"] = "claiming-tool-subscription-master";
    RolesEnum["RefundMaster"] = "refund-master";
    RolesEnum["PayoutMaster"] = "payout-master";
    RolesEnum["CAMaster"] = "ca-master";
    RolesEnum["Finance"] = "finance";
    RolesEnum["FinanceMaster"] = "finance-master";
    RolesEnum["Product"] = "product";
    RolesEnum["Admin"] = "admin";
    RolesEnum["UserRoleManager"] = "user-role-manager";
    RolesEnum["DriverFaqManager"] = "driver-faq-manager";
    // -- Roles not assignable from users page. Assigned from code and stored in DB --
    RolesEnum["Driver"] = "driver";
    RolesEnum["DriversCompany"] = "drivers-company";
    RolesEnum["DriversCompanyDriver"] = "drivers-company-driver";
    // NOTE: the following roles are commented out to enforce using the helper functions instead
    // -- Customer and TravelAgent related roles. Never stored in DB but assigned on login time --
    // legacy site roles
    // SiteCustomerInterface = "site-customer-customer-interface",
    // SiteCustomerBookingProcess = "site-customer-booking-process",
    // SiteCustomerTripTracking = "site-customer-trip-tracking",
    // // new general customer roles
    // CustomerInterface = "customer",
    // CustomerBookingProcess = "customer-booking-process",
    // CustomerTripTracking = "customer-trip-tracking",
    RolesEnum["TravelAgent"] = "travel-agent";
    RolesEnum["HostAgencyAdmin"] = "host-agency-admin";
    // -- Integration roles assigned in DB only
    RolesEnum["BlacklistedDatesApiIntegration"] = "blacklisted-dates-api-integration";
    RolesEnum["Developer"] = "developer";
})(RolesEnum || (exports.RolesEnum = RolesEnum = {}));
exports.CUSTOMER_INTERFACE_ROLES = Object.seal(["site-customer-customer-interface", "customer"]);
exports.CUSTOMER_BOOKING_PROCESS_ROLES = Object.seal(["site-customer-booking-process", "customer-booking-process"]);
exports.CUSTOMER_TRIP_TRACKING_ROLES = Object.seal(["site-customer-trip-tracking", "customer-trip-tracking"]);
function includesCustomerInterfaceRole(roles) {
    return exports.CUSTOMER_INTERFACE_ROLES.some((role) => roles.includes(role));
}
function includesCustomerBookingProcessRole(roles) {
    return exports.CUSTOMER_BOOKING_PROCESS_ROLES.some((role) => roles.includes(role));
}
function includesCustomerTripTrackingRole(roles) {
    return exports.CUSTOMER_TRIP_TRACKING_ROLES.some((role) => roles.includes(role));
}
//# sourceMappingURL=AllRoles.js.map